import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
        key: 'auth-callback',
        path: `${AUTH_PREFIX_PATH}/callback`,
        component: React.lazy(() => import('views/auth-views/authentication/callback')),
    },
    {
        key: 'register',
        path: `${AUTH_PREFIX_PATH}/register`,
        component: React.lazy(() => import('views/auth-views/authentication/register')),
    },
    {
        key: 'forgot-password',
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
    }
]

export const protectedRoutes = [
    {
        key: 'homecoming.dashboard',
        path: `${APP_PREFIX_PATH}/dashboard`,
        component: React.lazy(() => import('views/app-views/homecoming/dashboard')),
    },
    {
        key: 'homecoming.letters',
        path: `${APP_PREFIX_PATH}/letters`,
        component: React.lazy(() => import('views/app-views/homecoming/letters')),
    },
    {
        key: 'homecoming.prayer-list',
        path: `${APP_PREFIX_PATH}/prayer-list`,
        component: React.lazy(() => import('views/app-views/homecoming/prayer-list')),
    },
    {
        key: 'homecoming.phone-calls',
        path: `${APP_PREFIX_PATH}/phone-calls`,
        component: React.lazy(() => import('views/app-views/homecoming/phone-calls')),
    },
    {
        key: 'homecoming.missing-contact-info',
        path: `${APP_PREFIX_PATH}/missing-contact-info`,
        component: React.lazy(() => import('views/app-views/homecoming/missing-contact-info')),
    },
    {
        key: 'homecoming.calendar',
        path: `${APP_PREFIX_PATH}/calendar`,
        component: React.lazy(() => import('views/app-views/homecoming/calendar')),
    },
    {
        key: 'homecoming.giveaway',
        path: `${APP_PREFIX_PATH}/giveaway`,
        component: React.lazy(() => import('views/app-views/homecoming/giveaway')),
        meta: {
            blankLayout: true
        }
    },
    {
        key: 'homecoming.admin',
        path: `${APP_PREFIX_PATH}/admin`,
        component: React.lazy(() => import('views/app-views/homecoming/admin')),
    },
    {
        key: 'homecoming.help',
        path: `${APP_PREFIX_PATH}/help`,
        component: React.lazy(() => import('views/app-views/homecoming/help')),
    },
    {
        key: 'homecoming.root',
        path: `${APP_PREFIX_PATH}/homecoming`,
        component: React.lazy(() => import('views/app-views/homecoming/dashboard')),
    },
    {
        key: 'app.root',
        path: `${APP_PREFIX_PATH}`,
        component: React.lazy(() => import('views/app-views/homecoming/dashboard')),
    }
]